<template>
  <div class="phywe-item-accordion accordion">
      <div class="widget komponent-off mb-5 mt-5 mt-lg-0" v-if="komponente.length > 0">
        <h3>{{ $translate("Phywe::Template.singleBestandteil") }}</h3>
        <div class="componentoff" v-for="result in komponente">
          <div class="row" v-if="result.more.data.images.all">
            <div class="col-lg-4 text-center">
              <img v-if="result.more.data.images.all.length > 0" :src="result.more.data.images.all[0].urlMiddle" class="img-fluid">
              <img v-else src="/images/produkte/no_image.png" class="img-fluid">
            </div>
            <div class="col-lg-8">
              <a class="h3 d-block" :href="result | correctLang('url')" v-html="result.more.data.texts.name1"></a>
              <div class="single-headline">
                <p>
                  {{ $translate("Phywe::Template.sbindingTableCell2") }}
                  {{ result.more.data.variation.number }}
                  {{ $translate("Phywe::Template.globalType") }} Set
                </p>
              </div>
              <div class="pricebox">
                <div class="availbox" v-if="result.more.data.variation.availability.id !== 7 && result.more.data.variation.availability.id !== 6">
                  {{ $translate("Phywe::Template.singleLieferzeit") }}
                  <template v-if="PID==49089">
                    <span class="availability badge availability-1">
                      <span>
                        {{ $translate("Phywe::Template.singleLieferzeitSchweiz") }}
                      </span>
                    </span>
                  </template>
                  <template v-else>
                    <span :class="'availability badge availability-'+result.more.data.variation.availability.id">
                      <span>
                        {{ result.more.data.variation.availability.names.name }}
                      </span>
                    </span>
                  </template>
                </div>
                <template v-if="PID!==49091">
                  <template v-if="result.more.data.prices.default.data.basePriceNet != 0">
                    <div>
                      {{ result.more.data.prices.default.data.basePriceNet | currency }} {{ $translate("Ceres::Template.itemExclVAT") }}
                    </div>
                    <span class="font-weight-normal">{{ result.more.data.prices.default.data.basePrice | currency }} {{ $translate("Ceres::Template.itemInclVAT") }}</span>
                  </template>
                </template>
              </div>
            </div>
          </div>
      </div>
      </div>
      <div class="card" data-step="description" v-if="current.texts.description">
        <div class="card-header">
          <h2 class="mb-0">
            <button class="d-flex btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#beschreibung" aria-expanded="true" aria-controls="collapseOne">
              <div>{{ $translate("Phywe::Template.sbindingBeschreibung") }}</div>
              <i class="flex-fill ml-3 fa fa-caret-down"></i>
            </button>
          </h2>
        </div>
        <div id="beschreibung" class="collapse show" aria-labelledby="description">
          <div class="card-body px-0" v-html="current.texts.description"></div>
        </div>
      </div >
      <div class="card" data-step="variations" v-if="variationLength">
      <div class="card-header">
        <h2 class="mb-0">
          <button class="d-flex btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#variations" aria-expanded="true" aria-controls="collapseOne">
            <div>{{ $translate("Phywe::Template.sbindingMoreVariations") }} <span v-html="current.texts.name1"></span></div>
            <i class="flex-fill ml-3 fa fa-caret-down"></i>
          </button>
        </h2>
      </div>
      <div id="variations" class="collapse show">
        <div class="card-body coloredRow px-0">
          <div class="mb-3 font-weight-bold d-none d-lg-flex table-header">
            <div class="col-6 col-lg-1 pl-3">
              {{ getCurrentAttr }}
            </div>
            <div class="col-6 col-lg-2 text-right text-lg-left">
              {{ $translate("Phywe::Template.tableNr") }}
            </div>
            <template v-if="variationUnit == 'EA'">
              <div class="col-lg-6 pl-lg-0">
                {{ $translate("Phywe::Template.tablePrice") }}
              </div>
            </template>
            <template v-else>
              <div class="col-lg-4 pl-lg-0">
                {{ $translate("Phywe::Template.tablePrice") }}
              </div>
            </template>
            <div class="col-12 col-lg-2 text-lg-right" v-if="variationUnit == 'PK'">
              {{ $translate("Phywe::Template.tableInhalt") }}
            </div>
            <div class="col-12 col-lg-3 mt-3 mt-lg-0 text-lg-right">
              {{ $translate("Phywe::Template.tableMenge") }}
            </div>
          </div>
          <div class="row mb-3 align-items-center"  v-for="variation in variationsData.pack" v-if="variationUnit == 'PK'">
            <div class="col-6 col-lg-1 pl-3 font-weight-bold">
              {{ variation.data.attributes[0].value.names[0].name }}
            </div>
            <div class="col-6 col-lg-2 text-right text-lg-left">
              <span class="d-lg-none">{{ $translate("Phywe::Template.globalArtikelNr") }} </span> {{ variation.data.variation.number | removepack }}
            </div>
            <div class="col-lg-4 pl-lg-0">
              {{ variation.data.prices.default.price.formatted }} {{ $translate("Ceres::Template.itemExclVAT") }}
              <span class="smaller">( {{ variation.data.prices.default.data.basePrice | currency }}  {{ $translate("Ceres::Template.itemInclVAT") }})</span>
              <div class="text-green">
                {{ $translate("Phywe::Template.singleEntspricht") }} {{ variation.data.prices.default.price.value / variation.data.variation.unitsContained | currency }} /

                {{ $translate("Phywe::Template.singleUnitsS") }}
                -
                {{ $translate("Phywe::Template.singleSaving") }} {{ variation.ersparnisProzent }}%
              </div>
            </div>
            <div class="col-12 col-lg-2 text-lg-right">
              {{ $translate("Phywe::Template.globalInhalt") }}
              <br class="d-none d-lg-block">
              <span v-html="variation.data.variation.unitsContained"></span>
              {{ $translate("Phywe::Template.singleUnitsS") }}
            </div>
            <div class="col-12 col-lg-3 mt-3 mt-lg-0">
              <div class="d-flex justify-content-end">
                <div class="input-unit mb-0" v-if="variations.pack.length > 0">
                  <select class="switch-box custom-select" @change="changeUnit($event)">
                    <option value="PK" selected>{{ $translate("Phywe::Template.singleUnitsP") }}</option>
                    <option value="EA">{{ $translate("Phywe::Template.singleUnitsS") }}</option>
                  </select>
                </div>
                <div class="add-to-basket-container">
                  <div class="quantity-input-container mr-0 ml-2">
                    <div class="qty-box d-flex h-100">
                      <button  @click="minusMenge(variation)"  data-testing="quantity-btn-decrease" aria-label="Menge verringern" class="btn qty-btn flex-fill d-flex justify-content-center align-items-center p-0">
                        <i aria-hidden="true" class="fa fa-caret-left default-float"></i>
                      </button>

                      <input type="text" aria-label="Mengeneingabe" class="qty-input text-center flex-fill" v-model.number="variation.quantity">

                      <button  @click="plusMenge(variation)"  data-testing="quantity-btn-increase"  aria-label="Menge erhöhen" class="btn qty-btn flex-fill d-flex justify-content-center align-items-center p-0">
                        <i aria-hidden="true" class="fa fa-caret-right default-float"></i>
                      </button>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="row mb-3 align-items-center"  v-for="variation in variationsData.single" v-if="variationUnit == 'EA'">
            <div class="col-6 col-lg-1 pl-3 font-weight-bold">
              {{ variation.data.attributes[0].value.names[0].name }}
            </div>
            <div class="col-6 col-lg-2 text-right text-lg-left">
              <span class="d-lg-none">{{ $translate("Phywe::Template.globalArtikelNr") }} </span> {{ variation.data.variation.number | removepack }}
            </div>
            <div class="col-lg-6 pl-lg-0">
              {{ variation.data.prices.default.price.formatted }} {{ $translate("Ceres::Template.itemExclVAT") }}
              <span class="smaller">( {{ variation.data.prices.default.data.basePrice | currency }}  {{ $translate("Ceres::Template.itemInclVAT") }})</span>
            </div>
            <div class="col-12 col-lg-3 mt-3 mt-lg-0">
              <div class="d-flex justify-content-end">
                <div class="input-unit mb-0" v-if="variations.pack.length > 0">
                  <select class="switch-box custom-select" @change="changeUnit($event)">
                    <option value="PK">{{ $translate("Phywe::Template.singleUnitsP") }}</option>
                    <option value="EA" selected>{{ $translate("Phywe::Template.singleUnitsS") }}</option>
                  </select>
                </div>
                <div class="add-to-basket-container">
                  <div class="quantity-input-container mr-0 ml-2">
                    <div class="qty-box d-flex h-100">
                      <button  @click="minusMenge(variation)"  data-testing="quantity-btn-decrease" aria-label="Menge verringern" class="btn qty-btn flex-fill d-flex justify-content-center align-items-center p-0">
                        <i aria-hidden="true" class="fa fa-caret-left default-float"></i>
                      </button>

                      <input type="text" aria-label="Mengeneingabe" class="qty-input text-center flex-fill" v-model.number="variation.quantity">

                      <button  @click="plusMenge(variation)"  data-testing="quantity-btn-increase"  aria-label="Menge erhöhen" class="btn qty-btn flex-fill d-flex justify-content-center align-items-center p-0">
                        <i aria-hidden="true" class="fa fa-caret-right default-float"></i>
                      </button>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="row" v-if="variationUnit == 'PK'">
            <div class="col-12 text-right">
              <button class="btn btn-primary btn-appearance btn-large col-12 col-lg-3" @click="buyall(variationsData.pack)" :disabled="isLoading || disabledPK">
                {{ $translate("Ceres::Template.singleItemAddToBasket") }}
                <i class="fa fa-spin fa-circle-o-notch float-none ml-2" v-if="isLoading"></i>
              </button>
            </div>
          </div>
          <div class="row" v-if="variationUnit =='EA'">
            <div class="col-12 text-right">
              <button class="btn btn-primary btn-appearance btn-large col-12 col-lg-3" @click="buyall(variationsData.single)" :disabled="isLoading || disabeledSingle">
                {{ $translate("Ceres::Template.singleItemAddToBasket") }}
                <i class="fa fa-spin fa-circle-o-notch float-none ml-2" v-if="isLoading"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div class="card" data-step="versuche" v-if="versuche.length > 0">
        <div class="card-header">
          <h2 class="mb-0">
            <button class="d-flex btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#versuche" aria-expanded="true" aria-controls="collapseOne">
              <div>{{ $translate("Phywe::Template.sbindingVersuche") }}</div>
              <i class="flex-fill ml-3 fa fa-caret-down"></i>
            </button>
          </h2>
        </div>
        <div id="versuche" class="collapse">
          <div class="card-body px-0">
            <div class="grey p-4">
              <div class="row mt-4 mb-4">
                <div class="col-9 col-lg-6 font-weight-bold">{{ $translate("Phywe::Template.sbindingTableCell1") }}</div>
                <div class="d-none d-lg-block col-lg-3 font-weight-bold">{{ $translate("Phywe::Template.sbindingTableCell2") }}</div>
                <div class="d-none d-lg-block col-lg-3 font-weight-bold">{{ $translate("Phywe::Template.sbindingTableCell6") }}</div>
              </div>
              <div class="itemslist">
                <template v-for="versuch in versuche">
                  <div class="row itemblocks mt-3">
                    <div class="col-10 col-lg-6 order-0 order-lg-0">
                      <a :href="versuch | correctLang('url')">
                        {{ versuch | correctLang('name') }}
                      </a>
                    </div>
                    <div class="col-12 col-lg-3 order-2 order-lg-1">
                      <span class="d-lg-none text-muted">{{ $translate("Phywe::Template.sbindingTableCell2") }}</span>
                      <a v-html="versuch.mappedTo" :href="versuch | correctLang('url')"></a>
                    </div>
                    <div class="col-12 col-lg-3 order-2 order-lg-1">
                      <template v-if="getCurricuLab(versuch.properties).length > 0">
                        <span class="d-lg-none text-muted">{{ $translate("Phywe::Template.sbindingTableCell6") }}</span>
                        <a :href="getCurricuLab(versuch.properties)[0].value" target="_blank">
                          <img src="https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/curricuLAB-xsmall.png" alt="curricuLAB" title="curricuLAB" class="img-fluid">
                        </a>
                      </template>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card" data-step="lieferumfang" v-if="lieferumfang.length > 0">
      <div class="card-header">
        <h2 class="mb-0">
          <button class="d-flex btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#lieferumfang" aria-expanded="true" aria-controls="collapseOne">
            <div>{{ $translate("Phywe::Template.sbindingLieferumfang") }}</div>
            <i class="flex-fill ml-3 fa fa-caret-down"></i>
          </button>
        </h2>
      </div>
      <div id="lieferumfang" class="collapse">
        <div class="card-body px-0">
          <div class="grey p-4">
            <div class="row mt-4 mb-4">
              <div class="col-9 col-lg-9 font-weight-bold">{{ $translate("Phywe::Template.sbindingTableCell1") }}</div>
              <div class="d-none d-lg-block col-lg-2 font-weight-bold">{{ $translate("Phywe::Template.sbindingTableCell2") }}</div>
              <div class="col-3 d-lg-block col-lg-1 font-weight-bold">{{ $translate("Phywe::Template.gMenge") }}</div>
            </div>
            <div class="itemslist">
              <template v-for="umfang in lieferumfang">
                <div class="row itemblocks mt-3">
                  <div class="col-10 col-lg-9 order-0 order-lg-0">
                    <a :href="umfang | correctLang('url')">
                      <span v-html="umfang.more.data.texts.name1"></span>
                      <template v-if="umfang.more.data.attributes.length > 0">
                        |
                        <template v-for="attr in umfang.more.data.attributes">
                          <span v-html="attr.attribute.names.name"></span>:
                          <span v-html="attr.value.names.name"></span>
                        </template>
                      </template>
                    </a>
                  </div>
                  <div class="col-12 col-lg-2 order-2 order-lg-1">
                    <span class="d-lg-none text-muted">{{ $translate("Phywe::Template.sbindingTableCell2") }}</span>
                    <a v-html="umfang.more.data.variation.number" :href="umfang | correctLang('url')"></a>
                  </div>
                  <div class="col-1 col-lg-1 order-1 order-lg-2 d-flex align-items-center justify-content-center">
                    {{ umfang.quantity | numberFormat }}
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div class="card" data-step="zubehoer" v-if="zubehoerData != null">
        <div class="card-header" >
          <h2 class="mb-0">
            <button class="d-flex btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#zubehoer" aria-expanded="true" aria-controls="collapseOne">
              <div>{{ $translate("Phywe::Template.sbindingGroupZubehor") }}</div>
              <i class="flex-fill ml-3 fa fa-caret-down"></i>
            </button>
          </h2>
        </div>
        <div id="zubehoer" class="collapse" aria-labelledby="Zubehoer">
          <div class="card-body px-0">
            <div class="grey p-4" v-if="zubehoer.notwendig.length > 0">
              <i class="icon-warning-black table-icon d-none d-lg-block"></i>
              <h3>{{ $translate("Phywe::Template.sbindingZubehor2") }}</h3>
              <p class="text-red">{{ $translate("Phywe::Template.sbindingZubehorslogan2") }}</p>
              <div class="row mt-4 mb-4">
                <div class="d-none d-lg-block col-lg-9 font-weight-bold">{{ $translate("Phywe::Template.sbindingTableCell2") }}</div>
                <div class="d-none d-lg-block col-lg-2 font-weight-bold">{{ $translate("Phywe::Template.sbindingTableCell2") }}</div>
                <div class="d-none d-lg-block col-lg-1 font-weight-bold"></div>
              </div>
              <template v-for="zubehoeritem in zubehoer.notwendig">
                <div class="row itemblocks mt-3">
                  <div class="col-10 col-lg-9 order-0 order-lg-0">
                    <a :href="zubehoeritem| correctLang('url')">
                      {{ zubehoeritem | correctLang('name') }}
                    </a>
                  </div>
                  <div class="col-12 col-lg-2 order-2 order-lg-1">
                    <span class="d-lg-none text-muted">{{ $translate("Phywe::Template.sbindingTableCell2") }}</span>
                    <a v-html="zubehoeritem.mappedTo" :href="zubehoeritem | correctLang('url')"></a>
                  </div>
                  <div class="col-2 col-lg-1 order-1 order-lg-2 d-flex align-items-center justify-content-center">
                    <template v-if="zubehoeritem.isLoading">
                      <div>
                        <i class="fa fa-spin fa-circle-o-notch"></i>
                      </div>
                    </template>
                    <template v-else>
                      <div @click="buyItem(zubehoeritem.item.mainVariationId,zubehoeritem.texts,zubehoeritem)">
                        <i class="icon-add_shopping-black"></i>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
            </div>
            <div class="grey p-4" v-if="zubehoer.empfohlen.length > 0" :class="{'mt-5': zubehoer.notwendig.length > 0 }">
              <i class="icon-Mehrwert_black table-icon d-none d-lg-block text-green"></i>
              <h3>{{ $translate("Phywe::Template.sbindingZubehor") }}</h3>
              <p class="text-green">{{ $translate("Phywe::Template.sbindingZubehorslogan1") }}</p>
              <div class="row mt-4 mb-4">
                <div class="d-none d-lg-block col-lg-9 font-weight-bold">{{ $translate("Phywe::Template.sbindingTableCell1") }}</div>
                <div class="d-none d-lg-block col-lg-2 font-weight-bold">{{ $translate("Phywe::Template.sbindingTableCell2") }}</div>
                <div class="d-none d-lg-block col-lg-1 font-weight-bold">&nbsp;</div>
              </div>
              <div class="itemslist">
                <template v-for="zubehoeritem in zubehoer.empfohlen">
                  <div class="row itemblocks mt-3">
                    <div class="col-10 col-lg-9 order-0 order-lg-0">
                      <a :href="zubehoeritem| correctLang('url')">
                        {{ zubehoeritem | correctLang('name') }}
                      </a>
                    </div>
                    <div class="col-12 col-lg-2 order-2 order-lg-1">
                      <span class="d-lg-none text-muted">{{ $translate("Phywe::Template.sbindingTableCell2") }}</span>
                      <a v-html="zubehoeritem.mappedTo" :href="zubehoeritem | correctLang('url')"></a>
                    </div>
                    <div class="col-2 col-lg-1 order-1 order-lg-2 d-flex align-items-center justify-content-center">
                      <template v-if="zubehoeritem.isLoading">
                        <div>
                          <i class="fa fa-spin fa-circle-o-notch"></i>
                        </div>
                      </template>
                      <template v-else>
                        <div @click="buyItem(zubehoeritem.item.mainVariationId,zubehoeritem.texts,zubehoeritem)">
                          <i class="icon-add_shopping-black"></i>
                        </div>
                      </template>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="grey p-4" v-if="zubehoer.kompatibles.length > 0" :class="{'mt-5': zubehoer.notwendig.length > 0 || zubehoer.empfohlen.length }">
              <h3>{{ $translate("Phywe::Template.sbindingZubehor3") }}</h3>
              <p class="text-green">{{ $translate("Phywe::Template.sbindingZubehorslogan3") }}</p>
              <div class="row mt-4 mb-4">
                <div class="d-none d-lg-block col-lg-9 font-weight-bold">{{ $translate("Phywe::Template.sbindingTableCell1") }}</div>
                <div class="d-none d-lg-block col-lg-2 font-weight-bold">{{ $translate("Phywe::Template.sbindingTableCell2") }}</div>
                <div class="d-none d-lg-block col-lg-1 font-weight-bold">&nbsp;</div>
              </div>
              <div class="itemslist">
                <template v-for="zubehoeritem in zubehoer.kompatibles">
                  <div class="row itemblocks mt-3">
                    <div class="col-10 col-lg-9 order-0 order-lg-0">
                      <a :href="zubehoeritem| correctLang('url')">
                        {{ zubehoeritem | correctLang('name') }}
                      </a>
                    </div>
                    <div class="col-12 col-lg-2 order-2 order-lg-1">
                      <span class="d-lg-none text-muted">{{ $translate("Phywe::Template.sbindingTableCell2") }}</span>
                      <a v-html="zubehoeritem.mappedTo" :href="zubehoeritem | correctLang('url')"></a>
                    </div>
                    <div class="col-2 col-lg-1 order-1 order-lg-2 d-flex align-items-center justify-content-center">
                      <template v-if="zubehoeritem.isLoading">
                        <div>
                          <i class="fa fa-spin fa-circle-o-notch"></i>
                        </div>
                      </template>
                      <template v-else>
                        <div @click="buyItem(zubehoeritem.item.mainVariationId,zubehoeritem.texts,zubehoeritem)">
                          <i class="icon-add_shopping-black"></i>
                        </div>
                      </template>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card" data-step="mediafiles" v-if="media.length > 0 || getCurricuLabBig(current.variationProperties).length > 0">
        <div class="card-header">
          <h2 class="mb-0">
            <button class="d-flex btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#media" aria-expanded="true" aria-controls="collapseOne">
              <div>{{ $translate("Phywe::Template.sbindingMedia") }}</div>
              <i class="flex-fill ml-3 fa fa-caret-down"></i>
            </button>
          </h2>
        </div>
        <div id="media" class="collapse" aria-labelledby="Mediafiles">
          <div class="card-body px-0">
            <div class="grey p-4">
              <div class="row mt-0 mb-4 d-none d-lg-flex">
              <div class="col-12 col-lg-5 font-weight-bold">{{ $translate("Phywe::Template.sbindingTableCell0") }}</div>
              <div class="d-none d-lg-block col-lg-2 font-weight-bold">{{ $translate("Phywe::Template.sbindingTableCell4") }}</div>
              <div class="d-none d-lg-block col-lg-2 font-weight-bold">{{ $translate("Phywe::Template.sbindingTableCell3") }}</div>
              <div class="d-none d-lg-block col-lg-1 font-weight-bold">{{ $translate("Phywe::Template.sbindingTableCell5") }}</div>
              <div class="d-lg-block col-lg-2 font-weight-bold">{{ $translate("Phywe::Template.sbindingTableCell6") }}</div>
            </div>
              <template v-for="mediaFile in media">
              <template v-if="mediaFile.fileExtension == 'exe' || mediaFile.fileExtension=='msi' || mediaFile.fileExtension=='pkg' || mediaFile.fileExtension=='dmg'">
                <div class="row itemblocks mt-3">
                  <div class="col-10 col-lg-7 order-0 order-lg-0">
                    <a v-html="'('+mediaFile.lang+')'+' '+mediaFile.fileExternalComment" class="cursor" :href="mediaFile.fileInternalComment" target="_blank"></a>
                  </div>
                  <div class="col-12 col-lg-2 order-2 order-lg-1">
                    <span class="d-lg-none text-muted">{{ $translate("Phywe::Template.sbindingTableCell3") }}</span>
                    <span></span>
                  </div>
                  <div class="d-none d-lg-flex col-lg-1 order-1 order-lg-2 align-items-center justify-content-center">
                    <div v-html="mediaFile.fileExtension"></div>
                  </div>
                  <div class="d-lg-flex col-lg-2 order-1 order-lg-2 align-items-center justify-content-start">
                    <div> - </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="row itemblocks mt-3">
                  <div class="col-10 col-lg-5 order-0 order-lg-0">
                    <div v-html="'('+mediaFile.lang+')'+' '+mediaFile.fileExternalComment" @click="getFileContent(mediaFile)" class="cursor"></div>
                  </div>
                  <div class="col-12 col-lg-2">
                    <span v-html="mediaFile.fileName"></span>
                    <span class="d-lg-none">.<span v-html="mediaFile.fileExtension"></span></span>
                  </div>
                  <div class="col-12 col-lg-2 order-2 order-lg-1">
                    <span class="d-lg-none text-muted">{{ $translate("Phywe::Template.sbindingTableCell3") }}</span>
                    <span>{{ (mediaFile.fileSize / 1000000).toFixed(2) }} Mb</span>
                  </div>
                  <div class="d-none d-lg-flex col-lg-1 order-1 order-lg-2 align-items-center justify-content-center">
                    <div v-html="mediaFile.fileExtension"></div>
                  </div>
                  <div class="d-lg-flex col-lg-2 order-1 order-lg-2 align-items-center justify-content-start">
                    <div> - </div>
                  </div>
                </div>
              </template>
              </template>
              <template v-if="getCurricuLabBig(current.variationProperties).length > 0">
                <div class="row itemblocks mt-3">
                  <div class="col-10 col-lg-5 order-0 order-lg-0">
                    <div>{{ current.texts.name1 }}</div>
                  </div>
                  <div class="col-12 col-lg-2">
                    <span>-</span>
                    <span class="d-lg-none">.H5P</span>
                  </div>
                  <div class="col-12 col-lg-2 order-2 order-lg-1">
                    <span class="d-lg-none text-muted">{{ $translate("Phywe::Template.sbindingTableCell3") }}</span>
                    <span>-</span>
                  </div>
                  <div class="d-none d-lg-flex col-lg-1 order-1 order-lg-2 align-items-center justify-content-center">
                    <div>.H5P</div>
                  </div>
                  <div class="d-lg-flex col-lg-2 order-1 order-lg-2 align-items-center justify-content-start">
                    <a :href="getCurricuLabBig(current.variationProperties)[0]" target="_blank">
                      <img src="https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/curricuLAB-xsmall.png">
                    </a>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div >
  </div>
</template>

<script>
const NotificationService = require("../services/NotificationService");
import TranslationService from "../services/TranslationService";
import ExceptionMap from "../exceptions/ExceptionMap";
export default
{
  props: [
    "zubehoer",
    "komponente",
    "versuche",
    "lieferumfang",
    "media",
    "variations"
  ],
  data: function()
  {
    return {
      data:'',
      variationUnit:"PK",
      variationsData:null,
      zubehoerData:null,
      isLoading:false
    }
  },

  inject:
  {
    itemId:
    {
      default: null
    }
  },
  created:function()
  {
    this.variationsData = this.variations;
    if(this.zubehoer.notwendig.length > 0 || this.zubehoer.empfohlen.length > 0 || this.zubehoer.kompatibles.length > 0)
    {
      this.zubehoerAddLoad()
    }
    if(this.variations.pack.length > 0)
    {
      this.sortVars()
    }
    else
    {
      this.variationUnit  = "EA";
    }
  },
  methods:
  {
    getCurricuLabBig:function(propsall)
    {

      let link = []
      for(let i0 = 0; i0 < propsall.length; i0++)
      {
        if(propsall[i0].id === 1)
        {
          for (let i = 0; i < propsall[i0].properties.length; i++)
          {
            if (propsall[i0].properties[i].id === 193)
            {
              link.push(propsall[i0].properties[i].values.value)
            }
          }
        }
      }
      return link;
    },
    getCurricuLab:function(props)
    {
      let link = []
      for(let i = 0; i < props.length; i++)
      {
        if(props[i].propertyId === 193)
        {
          for(let i2 = 0; i2 < props[i].relationValues.length; i2++)
          {
            if(props[i].relationValues[i2].lang.toUpperCase() === App.language.toUpperCase())
            {
              link.push(props[i].relationValues[i2])
            }
          }
        }
      }
      return link;
    },
    buyItem:function(id,name,item)
    {
      item.isLoading  = true;
      let itemName    = name.filter(item => item.lang == App.language)[0];
      let postData    =
      {
        "items":
        [
          {
            "variationId": id,
            "quantity":1,
            "name":itemName
          }
        ]
      }
      $.ajax({
        type: 'POST',
        url: '/'+App.language+'/cartsave/addtobasket/',
        data: postData,
        success: function (data)
        {
          for( var i = 0; i < data.length; i++)
          {
            if(data[i].error)
            {
              CeresNotification.error(TranslationService.translate("YbbaCartSave::Template.notesNichtgenugbestand",
                  {
                    variationName: data[i].error.variationName,
                    stock: data[i].error.placeholder.stock
                  })
              );
            }
            else
            {
              CeresNotification.success(TranslationService.translate("YbbaCartSave::Template.notesArtikelhinzugefuegt")).closeAfter(3000);
            }
            if(i===data.length-1)
            {
              vueApp.$store.commit("setBasketItems", data[i].basketItems);
              vueApp.$store.commit("setBasket", data[i].basket);
            }
          }
          item.isLoading  = false;
        },
        error: function (jqXHR, textStatus, errorThrown)
        {
          item.isLoading  = false;
        }
      })
    },
    zubehoerAddLoad:function()
    {
      let data      = this.zubehoer;
      let _self     = this;
      let empfohlen   = [];
      let notwendig   = [];
      let kompatibles = [];

      for(let i = 0; i < data.empfohlen.length; i++)
      {
        data.empfohlen[i].isLoading = false;
        empfohlen.push(data.empfohlen[i]);
      }
      for(let i = 0; i < data.notwendig.length; i++)
      {
        data.notwendig[i].isLoading = false;
        notwendig.push(data.notwendig[i]);
      }
      for(let i = 0; i < data.kompatibles.length; i++)
      {
        data.kompatibles[i].isLoading = false;
        kompatibles.push(data.kompatibles[i]);
      }

      _self.zubehoerData =
      {
        "notwendig" : notwendig,
        "empfohlen" : empfohlen,
        "kompatibles": kompatibles
      };
      _self.$store.commit("setZubehoer",{
        "notwendig" : notwendig,
        "empfohlen" : empfohlen,
        "kompatibles": kompatibles
      });
    },
    singleCalc:function()
    {
      let _self = this;
      for (let i = 0; i < _self.variationsData.pack.length; i++)
      {
        for (let o = 0; o < _self.variationsData.single.length; o++)
        {
          // o is einzelpreis
          if (_self.variationsData.single[o].data.attributes[0].valueId == _self.variationsData.pack[i].data.attributes[0].valueId && _self.variationsData.single[o].data.unit.unitOfMeasurement != 'PK') {
            _self.variationsData.pack[i].singlePrice = _self.variationsData.single[o].data.prices;

            let einzelpreispack     = parseFloat(_self.variationsData.pack[i].data.prices.default.price.value) / parseFloat(_self.variationsData.pack[i].data.variation.unitsContained);
            let einzelpreissingle   = _self.variationsData.single[o].data.prices.default.price.value;
            let diff                = einzelpreissingle - einzelpreispack;
            let prozentunsauber     = (100 / einzelpreissingle) * diff;

            _self.variationsData.pack[i].ersparnisProzent = prozentunsauber.toFixed(0);
          }
        }
      }
      _self.$store.commit("setPhyweVariations", {"single":_self.variationsData.single,"pack":_self.variationsData.pack});
    },
    sortVars:function ()
    {
      function compare(a, b)
      {
        if (a.data.attributes[0].value.position < b.data.attributes[0].value.position)
          return -1;
        if (a.data.attributes[0].value.position > b.data.attributes[0].value.position)
          return 1;
        return 0;
      }
      this.variationsData.single.sort(compare);
      this.variationsData.pack.sort(compare);
      this.singleCalc()
    },
    buyall:function(itemsArray)
    {
      this.isLoading = true
      let _self      = this;
      let itemsToGet = itemsArray.filter(item => item.quantity > 0);
      let sendItems      = [];
      for(let i = 0; i < itemsToGet.length; i++)
      {
        sendItems.push(
        {
          "variationId": itemsToGet[i].data.variation.id,
          "quantity":itemsToGet[i].quantity,
          "name":itemsToGet[i].data.texts[0].name1
        });
        itemsToGet[i].quantity = 0;
      }
      $.ajax({
        type: 'POST',
        url: '/'+App.language+'/cartsave/addtobasket/',
        data: {"items":sendItems },
        dataType:'json',
        success: function (data)
        {
          _self.isLoading = false;
          for( var i = 0; i < data.length; i++)
          {
            console.log(data[i])
            if(data[i].error)
            {
              NotificationService.error(
                  TranslationService.translate(
                      "Ceres::Template." + ExceptionMap.get(data[i].error.code.toString()),
                      data[i].error.placeholder
                  )
              ).closeAfter(5000);
            }
            else
            {
              NotificationService.success(TranslationService.translate("YbbaCartSave::Template.notesArtikelhinzugefuegt")).closeAfter(3000);
            }
            if(i===data.length-1)
            {
              vueApp.$store.commit("setBasketItems", data[i].basketItems);
              vueApp.$store.commit("setBasket", data[i].basket);
            }
          }
        },
        error: function (jqXHR)
        {
          console.log(jqXHR);
          _self.isLoading = false;
        }
      })

    },
    plusMenge: function(variation)
    {
      variation.quantity = variation.quantity+1;
    },
    minusMenge: function(variation)
    {
      if(variation.quantity != 0)
      {
        variation.quantity = variation.quantity-1;
      }
    },
    changeUnit: function(event)
    {
      this.variationUnit = event.target.value;
    },
    currentVariation: function()
    {
      return this.$store.getters[`${this.itemId}/currentItemVariation`];
    },
    getFileContent: function(mediafile)
    {
      let id = mediafile.id;
      $.ajax(
          {
            type: 'GET',
            url: '/'+App.language+'/Ybba/MediaFiles/get/mf/'+id+'/',
            dataType: 'json',
            success: function (data)
            {
              const byteString    = window.atob( data.data );
              const arrayBuffer   = byteString.length;
              const int8Array     = new Uint8Array(arrayBuffer);
              for (let i = 0; i < byteString.length; i++)
              {
                int8Array[i] = byteString.charCodeAt(i);
              }
              let type = '';
              // https://www.sitepoint.com/mime-types-complete-list/
              if(data.type == 'pkg')
              {
                type = 'application/x-newton-compatible-pkg'
              }
              if(data.type == 'pdf')
              {
                type = 'application/pdf'
              }
              if(data.type == 'exe')
              {
                type = 'application/octet-stream'
              }
              if(data.type == 'jpg')
              {
                type = 'image/jpeg'
              }
              if(data.type == 'png')
              {
                type = 'image/png'
              }

              const blob      = new Blob([int8Array], { type: type} );
              const url       = window.URL.createObjectURL( blob );
              var anchor      = document.createElement("a");
              anchor.download = data.name+'.'+data.type;
              anchor.href     = url;
              anchor.click();
            },
            error: function (response)
            {
              console.log(response);
            }
          })


    },
  },
  computed:
  {
    PID:function()
    {
      return parseInt(App.pid);
    },
    getCurrentAttr:function()
    {

      if (this.currentVariation().attributes.length > 0)
      {
        return this.currentVariation().attributes[0].attribute.backendName;
      }
    },
    variationLength:function()
    {
      if(this.variations.pack.length > 0 || this.variations.single.length > 0)
      {
        return true;
      }
      else
      {
        return false;
      }
    },
    current:function()
    {
      return this.currentVariation();
    },
    disabledPK:function()
    {
      let find = this.variationsData.pack.filter(item => item.quantity > 0);
      if(find.length > 0)
      {
        return false
      }
      else
      {
        return true
      }
    },
    disabeledSingle:function()
    {
      let find = this.variationsData.single.filter(item => item.quantity > 0);
      if(find.length > 0)
      {
        return false
      }
      else
      {
        return true
      }
    }
  }
}
</script>
